import {
  CompaniesSearchParams,
  Company,
  CompanyAnalysisResponse,
  CompanyDetails,
  CompanyMember,
  CompanySocialNetwork,
  CompanySocialNetworkCreate,
  CreateCompanyRequest,
  UpdateCompanyRequest,
} from '../types';
import { apiForms, apiOrchestrator } from 'services/apiService';

// GET /companies/ - Listar companies com busca opcional
export const getCompanies = async (params?: CompaniesSearchParams): Promise<Company[]> => {
  const { data } = await apiOrchestrator.get<Company[]>('/companies/', {
    params,
  });
  return data;
};

// POST /companies/ - Criar nova company
export const createCompany = async (companyData: CreateCompanyRequest): Promise<Company> => {
  const { data } = await apiOrchestrator.post<Company>('/companies/', companyData);
  return data;
};

// GET /companies/{company_uuid} - Obter detalhes da company
export const getCompany = async (companyUuid: string): Promise<CompanyDetails> => {
  const { data } = await apiOrchestrator.get<CompanyDetails>(`/companies/${companyUuid}`);
  return data;
};

// PUT /companies/{company_uuid} - Atualizar company
export const updateCompany = async (
  companyUuid: string,
  companyData: UpdateCompanyRequest
): Promise<Company> => {
  const { data } = await apiOrchestrator.put<Company>(`/companies/${companyUuid}`, companyData);
  return data;
};

// POST /companies/upload-logo/{company_uuid} - Upload de logo
export const uploadCompanyLogo = async (companyUuid: string, logoFile: File): Promise<any> => {
  const formData = new FormData();
  formData.append('logo', logoFile);

  const { data } = await apiOrchestrator.post(`/companies/upload-logo/${companyUuid}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

// GET /companies/logo/{company_uuid} - Obter logo da company
export const getCompanyLogo = async (
  companyUuid: string,
  params?: { avatar?: boolean; cdn?: boolean }
): Promise<string> => {
  const { data } = await apiOrchestrator.get(`/companies/logo/${companyUuid}`, {
    params,
  });
  return data;
};

// GET /companies/{company_uuid}/members - Obter membros da company
export const getCompanyMembers = async (companyUuid: string): Promise<CompanyMember[]> => {
  const { data } = await apiOrchestrator.get<CompanyMember[]>(`/companies/${companyUuid}/members`);
  return data;
};

// GET /company-social-networks/{company_uuid} - Obter redes sociais da company
export const getCompanySocialNetworks = async (
  companyUuid: string
): Promise<CompanySocialNetwork[]> => {
  const { data } = await apiOrchestrator.get<CompanySocialNetwork[]>(
    `/company-social-networks/${companyUuid}`
  );
  return data;
};

// GET /company-social-networks/{id} - Obter rede social específica por ID
export const getCompanySocialNetwork = async (id: number): Promise<CompanySocialNetwork> => {
  const { data } = await apiOrchestrator.get<CompanySocialNetwork>(
    `/company-social-networks/${id}`
  );
  return data;
};

// POST /company-social-networks/ - Criar nova rede social para company
export const createCompanySocialNetwork = async (
  socialNetworkData: CompanySocialNetworkCreate
): Promise<CompanySocialNetwork> => {
  const { data } = await apiOrchestrator.post<CompanySocialNetwork>(
    '/company-social-networks/',
    socialNetworkData
  );
  return data;
};

// PUT /company-social-networks/{id} - Atualizar rede social da company
export const updateCompanySocialNetwork = async (
  id: number,
  socialNetworkData: Partial<CompanySocialNetworkCreate>
): Promise<CompanySocialNetwork> => {
  const { data } = await apiOrchestrator.put<CompanySocialNetwork>(
    `/company-social-networks/${id}`,
    socialNetworkData
  );
  return data;
};

// DELETE /company-social-networks/{id} - Deletar rede social da company
export const deleteCompanySocialNetwork = async (id: number): Promise<void> => {
  await apiOrchestrator.delete(`/company-social-networks/${id}`);
};

// GET /analysis/report/company - Obter relatório de análise da company
export const getCompanyAnalysisReport = async (
  companyUuid: string
): Promise<CompanyAnalysisResponse> => {
  const { data } = await apiForms.get<CompanyAnalysisResponse>(
    `/v1/analysis/report/company?company_uuid=${companyUuid}`
  );
  return data;
};
